import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Using images in Gatsby requires a few different plugins.`}</p>
    <p><strong parentName="p">{`Install`}</strong>{` `}<inlineCode parentName="p">{`gatsby-transformer-sharp`}</inlineCode>{` and `}<inlineCode parentName="p">{`gatsby-plugin-sharp`}</inlineCode>{` to transform and process your images. `}<inlineCode parentName="p">{`gatsby-image`}</inlineCode>{` is a package that includes a component you’ll use later in “View”.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      